<template>
    <v-container>
        <v-row no-gutters justify="center" align="center">
            <v-col cols="6" class="pl-12 pr-2">
                <v-card-title class="justify-center">
                    {{ translations.createStore[lang] }}
                </v-card-title>

                <v-form @submit.prevent="createStore(lang)">
                    <v-card-text class="pt-0">
                        <v-row
                            v-if="storeDetails.store_subscription_plan_id"
                            no-gutters
                            ><v-col cols="12">
                                <h4 class="subtitle-1 font-weight-bold mt-7">
                                    {{ translations.storeDetails[lang] }}
                                </h4>

                                <v-text-field
                                    v-model="storeDetails.name"
                                    :label="translations.storeName[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="new-password"
                                    :success="success.name"
                                    :error-messages="error.name"
                                    @focus="error.name = ''"
                                    @blur="validateName"
                                ></v-text-field>

                                <b-select
                                    v-model="storeDetails.country_id"
                                    :items="countries"
                                    item-text="name"
                                    item-value="country_id"
                                    :label="translations.storeCountry[lang]"
                                    no-top-margin
                                    :success="success.country"
                                    :error-messages="error.country"
                                    @focus="error.country = ''"
                                    @change="validateCountry"
                                ></b-select>

                                <Places
                                    :label="translations.address[lang]"
                                    :success="success.address"
                                    :error-messages="error.address"
                                    @focus="error.address = ''"
                                    @blur="validateAddress"
                                    @newAddress="setAddressDetails"
                                />

                                <v-text-field
                                    v-model="storeDetails.vat_number"
                                    :label="translations.vatNumber[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="new-password"
                                    :success="success.vatNumber"
                                    :error-messages="error.vatNumber"
                                    @focus="error.vatNumber = ''"
                                    @blur="validateVatNumber"
                                ></v-text-field>

                                <v-text-field
                                    v-model="storeDetails.email"
                                    type="email"
                                    :label="translations.email[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="new-password"
                                    :success="success.email"
                                    :error-messages="error.email"
                                    @focus="error.email = ''"
                                    @blur="validateEmail"
                                ></v-text-field>

                                <v-text-field
                                    v-model="storeDetails.primary_phone"
                                    v-mask="'##########'"
                                    :label="translations.primaryPhone[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="off"
                                    :success="success.primaryPhone"
                                    :error-messages="error.primaryPhone"
                                    @focus="error.primaryPhone = ''"
                                    @blur="validatePrimaryPhone"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-alert v-if="errorMessage" type="error">{{
                        errorMessage
                    }}</v-alert>

                    <v-card-actions>
                        <v-btn
                            type="submit"
                            color="secondary"
                            class="text-capitalize"
                            style="font-size: 1rem"
                            block
                            depressed
                            :disabled="!valid"
                        >
                            {{ translations.createStore[lang] }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-col>
            <v-col cols="5">
                <v-img
                    src="@/assets/register-image.png"
                    width="300"
                    class="mx-auto"
                ></v-img>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mdiAccount, mdiLock, mdiLockOutline, mdiEye } from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";

import axios from "axios";

import Places from "@/components/general/Places.vue";
import validators from "@/utils/validators/storePanel/createStore";
import translations from "@/utils/translations/register/createStore";

export default {
    name: "CreateStore",

    components: { Places },

    mixins: [validators, translations],

    data() {
        return {
            icons: { mdiAccount, mdiLock, mdiLockOutline, mdiEye },
            show: {
                password: false,
                confirmPassword: false,
            },
            isAddress: false,
        };
    },

    computed: {
        ...mapState("register", [
            "loading",
            "errorMessage",
            "storeDetails",
            "countries",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        appProvider: {
            get() {
                return this.$store.state.register.appProvider;
            },

            set(val) {
                this.setAppProvider(val);
            },
        },

        fullname: {
            get() {
                return this.$store.state.register.fullname;
            },

            set(val) {
                this.setFullname(val);
            },
        },

        password: {
            get() {
                return this.$store.state.register.password;
            },

            set(val) {
                this.setPassword(val);
            },
        },

        confirmPassword: {
            get() {
                return this.$store.state.register.confirmPassword;
            },

            set(val) {
                this.setConfirmPassword(val);
            },
        },
    },

    methods: {
        ...mapMutations("register", [
            "setAppProvider",
            "setFullname",
            "setPassword",
            "setConfirmPassword",
        ]),
        ...mapActions("register", ["createStore", "getCountries"]),
        ...mapActions(["checkVatNumber"]),

        setAddressDetails(place) {
            this.isAddress = place.isAddress;
            this.storeDetails.address = place.address;
            this.storeDetails.zip = place.zip;
            this.storeDetails.lat = place.lat;
            this.storeDetails.lon = place.lon;
        },
    },

    mounted() {
        this.$clearFocus();
        this.storeDetails = {};
        this.storeDetails.store_subscription_plan_id =
            localStorage.getItem("subscriptionPlan");
        this.getCountries();
    },
};
</script>
